<template>
    <vx-expandable-card>
        <template v-slot:header>Consent</template>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div>
                    <vx-label size="md">Consent Text</vx-label>
                    <vx-input
                        v-model="data.consent_text"
                        size="lg"
                        maxlength="500"
                        :disabled="!props.canEdit"
                        data-test="consent-text-input"
                        :error="displayFirstError(validation.consent_text.$errors)"
                    />
                </div>

                <div>
                    <vx-label size="md">Consent Button Label</vx-label>
                    <vx-input
                        v-model="data.consent_button"
                        size="lg"
                        maxlength="80"
                        :disabled="!props.canEdit"
                        data-test="consent-button-input"
                        :error="displayFirstError(validation.consent_button.$errors)"
                    />
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxInput, VxLabel } from '@voxie/frontend-components';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import type { TermFormData } from '~/services/adminTermsClient.types';

const props = defineProps<{
    canEdit: boolean;
}>();

const data = defineModel<TermFormData>({ required: true });

const validation = useVuelidate(
    {
        consent_text: { required, maxLength: maxLength(500) },
        consent_button: { required, maxLength: maxLength(80) },
    },
    data
);
</script>
